











































import Vue from 'vue';
// import TruncatedText from '@/vue-components/util/TruncatedText.vue';
import Curve1 from '@/assets/img/shapes/curves/curve-1.svg';
// import HeartSpark from '@/vue-components/sparks/HeartSpark.vue';
import AddSpark from '@/vue-components/sparks/AddSpark.vue';
import { SparkelloImageUtil, WebSpark } from '@/web';

export default Vue.component('SparkListItem', {
  components: {
    // TruncatedText,
    Curve1,
    AddSpark,
    // HeartSpark,
  },
  props: ['spark'],
  data() {
    return {
      showMoreFlag: false,
      sparkImageUri: '',
    };
  },
  created() {
    SparkelloImageUtil.instance.getRegularImageSource(this.spark.image).then(uri => {
      this.$data.sparkImageUri = uri;
      this.$forceUpdate();
    });
  },
});
